export default __webpack_public_path__ + "static/media/Rhino Ram.791ff223.png";